import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { EDITOR_ENTITY_ROOTS } from './internal/editorEntityRoots';

/**
 * Periodic refetch of every active editor query. Kept on a 5-minute cadence
 * so long-lived editor sessions don't drift from the server.
 */
export const useEditorBackgroundRefetch = () => {
    const queryClient = useQueryClient();

    useEffect(() => {
        const interval = setInterval(
            () => {
                for (const root of EDITOR_ENTITY_ROOTS) {
                    queryClient.refetchQueries({
                        queryKey: root,
                        type: 'active',
                    });
                }
            },
            5 * 60 * 1000,
        );

        return () => clearInterval(interval);
    }, [queryClient]);
};
